import { Box, Button, Checkbox, FormControlLabel, IconButton, InputAdornment, MenuItem, TextField, Typography, useTheme } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../../Redux/store"
import { setCompanyName, setCountry, setEmail, setFirstName, setIdNumber, setIdType, setLastName, setPassword, setPasswordConfirmation, setPhoneNumber, setProgress, setSubtitle } from "../Slices/accountCreationSlice"
import { useForm, Controller, FieldErrors } from "react-hook-form"
import { PatternFormat } from "react-number-format";
import { removeNonDigits } from "../../../Utils/String";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { useHasErrors } from "../../../Hooks/useHasErrors";

interface CompanyDetailsProps {}
interface CompanyDetailsForm {
    CompanyName: string;
    Email: string;
    Password: string;
    PasswordConfirmation: string; 
}

export const CompanyDetails = (props: CompanyDetailsProps) =>{
    /* ******************** Hooks ******************** */
    const theme = useTheme()
    const dispatch = useAppDispatch();
    const {
        control,
        handleSubmit,
        formState: {isDirty, errors}
    } = useForm<CompanyDetailsForm>({
        defaultValues: {
            CompanyName: "",
            Email: "",
            Password: "",
            PasswordConfirmation: "",
        }
    });
    const { hasErrors } = useHasErrors();
    /* ******************** Variables ******************** */
    const profileType = useAppSelector(state => state.AccountCreation.ProfileType);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
    /* ******************** Functions ******************** */
    dispatch(setSubtitle(`Provide a few details for your ${profileType} account`))
    const onSubmit = (data: CompanyDetailsForm) =>{ 
        dispatch(setCompanyName(data.CompanyName))
        dispatch(setEmail(data.Email))
        dispatch(setPassword(data.Password))
        dispatch(setPasswordConfirmation(data.PasswordConfirmation))
        dispatch(setProgress(80))
    }
    const handleBack = () =>{
        dispatch(setProgress(60))
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    console.log(errors)
    return (
        <>
            <Controller 
                name="CompanyName"
                control={control}
                rules={{required: true}}
                render={({ field }) =>(                     
                    <TextField
                        {...field}
                        error={hasErrors(field.name, errors)}
                        // helperText={hasErrors(field.name, errors)?"Required":""}
                        placeholder="Company Name"
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                    />
                )}
            />
            <Controller 
                name="Email"
                control={control}
                rules={{required: true}}
                render={({ field }) =>(  
                    <TextField
                        {...field}
                        error={hasErrors(field.name, errors)}
                        // helperText={hasErrors(field.name, errors)?"Required":""}
                        placeholder="Email address"
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                    />
                )}
            />
            <Controller 
                name="Password"
                control={control}
                rules={{required: true}}
                render={({ field }) =>(  
                    <TextField
                        {...field}
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        error={hasErrors(field.name, errors)}
                        // helperText={hasErrors(field.name, errors)?"Required":""}
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => setShowPassword(!showPassword)}
                                >
                                  {showPassword ? <Visibility color="primary"/> : <VisibilityOff color="primary"/>}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    /> 
                )}
            />
            <Controller 
                name="PasswordConfirmation"
                control={control}
                rules={{required: true}}
                render={({ field }) =>(  
                    <TextField
                        {...field}
                        placeholder="Confirm Password"
                        type={showPasswordConfirmation ? "text" : "password"}
                        error={hasErrors(field.name, errors)}
                        // helperText={hasErrors(field.name, errors)?"Required":""}
                        sx={{
                            marginBottom: "16px",
                            width: "300px"
                        }}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => setShowPasswordConfirmation(!showPasswordConfirmation)}
                                >
                                  {showPasswordConfirmation ? <Visibility color="primary"/> : <VisibilityOff color="primary"/>}
                                </IconButton>
                              </InputAdornment>
                            )
                          }}
                    /> 
                )}
            />
            <Box display={"flex"} flexDirection={"row"} justifyContent={"center"} alignItems={"center"} gap={2}>
                <Button variant="contained" size="large" color="secondary" onClick={handleBack}>Back</Button>
                <Button variant="contained" disabled={!isDirty} size="large" onClick={handleSubmit(onSubmit)}>Next</Button>
            </Box>
        </>
    )
}